import { Box, Typography } from "@mui/material";
import DataListingComponent from "../../Component/DataListGrid";
import { useEffect, useRef, useState } from "react";
import DropDownComponent from "../../Component/DropDownComponent";
import { AXIOS } from "../../Component/apiHelper";
import { apiList } from "../../Component/apiList";
import defaultUserImage from "../../Assets/Image/default.webp";
// import view from "../../Assets/Image/newView.webp";
import { toast } from "react-toastify";
import logo from "../../Assets/Image/question.webp";
import ConfirmationModal1 from "../../Component/ConfirmModal1";
// import block from "../../Assets/Image/newBlock.webp";
// import unblock from "../../Assets/Image/unblock.webp";
// import deleted from "../../Assets/Image/delete.webp";
import { useNavigate } from "react-router-dom";
import { RouteList } from "../../Component/RoutesList";
import BasicMenu from "../../Component/MenuOptioinComponent";
import { StatusList } from "../../Component/StatusList";
import DescriptionIcon from "@mui/icons-material/Description";
import BlockIcon from "@mui/icons-material/Block";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import ReportOffIcon from "@mui/icons-material/ReportOff";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";

const UserScreen = () => {
  const PAGE_SIZE_OPTIONS = [15];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [totalData, setTotalData] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filter, setFilter] = useState(99);
  const [accountFilter, setAccountFilter] = useState(99);
  const [TypeFilter, setTypeFilter] = useState(99);
  const [open, setOpen] = useState(false);
  const [actionParams, setActionParams] = useState({
    userId: null,
    status: null,
    currentStatus: null,
  });

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };
  const handleAccountFilterChange = (e) => {
    setAccountFilter(e.target.value);
  };
  const handleTypeFilterChange = (e) => {
    setTypeFilter(e.target.value);
  };

  const handleAction = async (userId, status) => {
    let toastMessage = getStatusMessage(status, "toast", "user");
    try {
      setIsActionLoading(true);
      const f = new FormData();
      f.append("status", status);
      f.append("user_id", userId);
      const res = await AXIOS.post(`${apiList.user.action}`, f);
      if (res?.s) {
        toast.success(toastMessage);
        await getData(
          page,
          rowsPerPage,
          filter,
          filterRef.current,
          accountFilter,
          accountFilterRef.current,
          TypeFilter,
          typeFilterRef.current,
          debouncedSearchTerm,
          searchRef.current
        );
      } else {
        toast.error(res?.m);
      }
      setIsActionLoading(false);
    } catch (error) {
      console.log(error);
      setIsActionLoading(false);
    }
  };

  const getStatusMessage = (status, type) => {
    const statusItem = StatusList.find((item) => item.code === status);
    return statusItem
      ? type === "toast"
        ? statusItem.toast
        : statusItem.message
      : "Are you sure?";
  };

  const handleDetailsNav = (data) =>
    navigate(RouteList.userDetails, {
      state: {
        userId: data?.id,
      },
    });

  const getMenuOptionList = (data) => {
    const status = data?.status;
    const isPending = status === 0;
    const isVerified = status === 1;
    const isFlegged = status === -2;
    const isSuspended = status === -3;
    const isBanned = status === -4;
    return [
      {
        action: () => handleDetailsNav(data),
        title: "View Details",
        isDisabled: false,
        isActive: user_Details_access ? true : false,
        icon: <DescriptionIcon style={{ color: "#fd5d29" }} />,
      },
      {
        action: () => {
          setOpen(true);
          setActionParams({
            userId: data?.id,
            status: isSuspended ? 1 : -3,
            currentStatus: status,
          });
        },
        title: isSuspended ? "Re-Active" : "Suspend",
        isDisabled: isBanned ? true : false,
        isActive: user_suspense_access ? true : false,
        icon: isSuspended ? (
          <PersonIcon style={{ color: "#fd5d29" }} />
        ) : (
          <PersonOffIcon style={{ color: "#fd5d29" }} />
        ),
      },
      {
        action: () => {
          setOpen(true);
          setActionParams({
            userId: data?.id,
            status: isFlegged ? 1 : -2,
            currentStatus: status,
          });
        },
        title: isFlegged ? "Unflag" : "Flag",
        isDisabled: isBanned  ? true : false,
        isActive: user_flag_access ? true : false,
        icon: isFlegged ? (
          <ReportOffIcon style={{ color: "#fd5d29" }} />
        ) : (
          <ReportGmailerrorredIcon style={{ color: "#fd5d29" }} />
        ),
      },
      {
        action: () => {
          setOpen(true);
          setActionParams({
            userId: data?.id,
            status: !isBanned && -4,
            currentStatus: status,
          });
        },
        title: isBanned ? "Banned" : "Ban(permanent)",
        isDisabled: isBanned  ? true : false,
        isActive: user_ban_access ? true : false,
        icon: <BlockIcon style={{ color: "#fd5d29" }} />,
      },
    ];
  };

  const filterOption = [
    { label: "All", value: 9 },
    {
      label: "Pending",
      value: "0",
    },
    { label: "Verified", value: "1" },
    { label: "Flagged", value: "-2" },
    { label: "Suspended", value: "-3" },
    { label: "Banned", value: "-4" },
  ];
  const AccountFilterOption = [
    { label: "All", value: 9 },
    {
      label: "Active",
      value: "1",
    },
    {
      label: "Inactive",
      value: "0",
    },
  ];
  const TypeFilterOption = [
    { label: "All", value: 9 },
    { label: "Individual", value: "1" },
    { label: "Business", value: "2" },
  ];

  const accesslist = JSON.parse(
    localStorage.getItem("Megalopolist-userData-roles")
  );
  const secondModule = accesslist?.find((module) => module.id === 2);
  const user_suspense_access = !!secondModule?.access?.find(
    (access) => access.id === 10 && access.admin_user_id
  );
  const user_Details_access = !!secondModule?.access?.find(
    (access) => access.id === 27 && access.admin_user_id
  );
  const user_flag_access = !!secondModule?.access?.find(
    (access) => access.id === 11 && access.admin_user_id
  );
  const user_ban_access = !!secondModule?.access?.find(
    (access) => access.id === 12 && access.admin_user_id
  );

  const columns = [
    {
      field: "rowid",
      headerName: "Sr.",
      width: 60,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        return cell?.row?.rowid + page * rowsPerPage;
      },
    },
    {
      field: "profile_img",
      headerName: "Profile",
      width: 90,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
          onClick={() => user_Details_access && handleDetailsNav(cell?.row)}
        >
          <img
            src={
              cell?.row?.profile_img
                ? apiList.baseURL + cell?.row?.profile_img
                : defaultUserImage
            }
            alt="profile"
            style={{ borderRadius: "12px", height: "35px", width: "35px" }}
          />
        </div>
      ),
    },

    {
      field: "username",
      headerName: "User Name",
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 350,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      flex: 1,
    },
    {
      field: "phno",
      headerName: "Number",
      width: 160,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        return cell?.row?.phno_cc && cell?.row?.phno
          ? cell?.row?.phno_cc + " " + cell?.row?.phno
          : "-";
      },
    },
    {
      field: "Account",
      headerName: "Account",
      width: 160,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        const { is_active } = cell?.row;
        const d =
          is_active === 0
            ? {
                lable: "Inactive",
                color: "grey",
              }
            : {
                lable: "Active",
              };
        return <span style={{ color: d?.color }}>{d?.lable}</span>;
      },
    },

    {
      field: "is_approve",
      headerName: "Type",
      width: 150,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        const g = cell?.row?.role;
        // const a = cell?.row?.is_approve === 1;

        return g === 2 ? (
          <Box
            sx={{
              color: "#FFF",
              border: "2px solid #FD5D29",
              width: "100px",
              borderRadius: "5px",
              height: "100%",
              background: "#FD5D29",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Business
          </Box>
        ) : (
          g === 1 && (
            <Box
              sx={{
                color: "#000",
                border: "2px solid #FD5D29",
                width: "100px",
                padding: 1,
                borderRadius: "5px",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Individual
            </Box>
          )
        );
      },
    },

    {
      field: "AccountStatus",
      headerName: "Status",
      width: 160,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        const { status } = cell?.row;
        const lable = StatusList?.find((x) => x?.code == status);
        return <span style={{ color: lable?.color }}>{lable?.name}</span>;
      },
    },
  ];

  if (
    user_Details_access ||
    user_ban_access ||
    user_flag_access ||
    user_suspense_access
  ) {
    let d = {
      field: "status",
      headerName: "Action",
      width: 100,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      display: "flex",
      align: "center",
      renderCell: (cell) => {
        const menuOptions = getMenuOptionList(cell?.row);
        return (
          <Box className="flexCenter" sx={{ height: "100%" }}>
            <BasicMenu rowData={cell?.row} options={menuOptions} />
          </Box>
        );
      },
    };
    columns.push(d);
  }

  const getData = async (
    page = 0,
    rowsPerPage = PAGE_SIZE_OPTIONS[0],
    filter,
    prevFilter,
    accountFilter,
    preAccountFilter,
    TypeFilter,
    preTypeFilterRef,
    search,
    prevSearch
  ) => {
    try {
      const count = page * rowsPerPage;
      setLoading(true);
      if (
        filter !== prevFilter ||
        search !== prevSearch ||
        accountFilter !== preAccountFilter ||
        TypeFilter !== preTypeFilterRef
      ) {
        setPage(0);
        setData([]);
      }

      let endPoint = `?skip=${count}&limit=${PAGE_SIZE_OPTIONS}`;
      if (search?.length > 0) {
        endPoint += `&search=${search?.trim()}`;
      }
      if (filter !== 99 && filter !== 9) {
        endPoint += `&status=${filter}`;
      }
      if (accountFilter !== 99 && accountFilter !== 9) {
        endPoint += `&is_active=${accountFilter}`;
      }
      if (TypeFilter !== 99 && TypeFilter !== 9) {
        endPoint += `&role=${TypeFilter}`;
      }

      const res = await AXIOS.get(`${apiList.user.getAll}${endPoint}`);
      if (res?.s) {
        const updatedData = res?.r;
        const serialData = updatedData?.map((x, i) => {
          return { ...x, rowid: i + 1 };
        });
        setData(serialData);
        page === 0 && setTotalData(res?.total ?? 0);
        setLoading(false);
      } else {
        toast.warn(res?.m);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const searchRef = useRef(debouncedSearchTerm);
  const filterRef = useRef(filter);
  const accountFilterRef = useRef(accountFilter);
  const typeFilterRef = useRef(TypeFilter);

  useEffect(() => {
    getData(
      page,
      rowsPerPage,
      filter,
      filterRef.current,
      accountFilter,
      accountFilterRef.current,
      TypeFilter,
      typeFilterRef.current,
      debouncedSearchTerm,
      searchRef.current
    );
    searchRef.current = debouncedSearchTerm;
    filterRef.current = filter;
    accountFilterRef.current = accountFilter;
    typeFilterRef.current = TypeFilter;
  }, [
    debouncedSearchTerm,
    filter,
    accountFilter,
    TypeFilter,
    rowsPerPage,
    page,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box className="flexBetween">
        <Typography>
          <h2> User Management </h2>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: "470px",
            width: "100%",
          }}
        >
          <input
            type="search"
            name="search"
            value={searchTerm?.trimStart()}
            placeholder="Search by name, email and number"
            style={{
              padding: "13px",
              height: "100%",
              borderRadius: "12px",
              border: "1px solid #FD5D29",
              backgroundColor: "#FFF6F3",
              color: "#FD5D29",
              width: "100%",
            }}
            onChange={(e) => setSearchTerm(e.target.value?.trimStart())}
            id="search"
          />
        </Box>
        <Box sx={{ gap: 2, display: "flex" }}>
          <DropDownComponent
            value={accountFilter}
            options={AccountFilterOption}
            modal={false}
            handleChange={handleAccountFilterChange}
            placeholder={"Account"}
            check={false}
            bgColor={"#FD5D2924"}
            color={"#fd5d29"}
          />

          <DropDownComponent
            value={TypeFilter}
            options={TypeFilterOption}
            modal={false}
            handleChange={handleTypeFilterChange}
            placeholder={"Type"}
            check={false}
            color={"#FD5D29"}
            bgColor={"#FD5D2924"}
          />
          <DropDownComponent
            value={filter}
            options={filterOption}
            modal={false}
            handleChange={handleFilterChange}
            placeholder={"Status"}
            check={false}
            color={"#FFF"}
            bgColor={"#FD5D29"}
          />
        </Box>
      </Box>
      <Box sx={{ height: "calc(100vh - 180px)" }}>
        <DataListingComponent
          data={data}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={loading}
          totalData={totalData}
          page={page}
          columns={columns}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />

        <ConfirmationModal1
          open={open}
          setOpen={setOpen}
          loading={isActionLoading}
          onConfirm={() =>
            handleAction(actionParams.userId, actionParams.status)
          }
          title="Confirmation"
          message={getStatusMessage(actionParams.status)}
          confirmText="Confirm"
          cancelText="Cancel"
        />
      </Box>
    </Box>
  );
};

export default UserScreen;
